<template>
  <div>
    <template>
      <div>
        <mdb-container class="text-justify text-monospace" style="margin-top: 6em">
          <h2 class="h1-responsive font-weight-bold mb-4 text-center">美国移民</h2>
          <mdb-row>
            <mdb-col md="4" class="d-flex">
              <mdb-card border="secondary" class="mb-3">
                <mdb-card-header><i class="fad fa-flag-usa mr-2"></i>美国EB-5投资移民</mdb-card-header>
                <mdb-card-body class="text-secondary">
                  <mdb-card-title tag="h5">项目优势</mdb-card-title>
                  <mdb-card-text  class="">1、对申请人无学历、语言、年龄要求，其配偶及未满21岁的未婚子女可一同申请（由于排期的产生，可携带子女的年龄视排期而定）

                    2、对申请人不要求具备任何商业背景

                    3、对申请人无资产要求，只需证明投资金额为合法所得
                  </mdb-card-text>
                  <a class="d-block text-right" @click="$router.push('/usa/eb5')">了解详情>></a>
                </mdb-card-body>
              </mdb-card>

            </mdb-col>
            <mdb-col md="4"  class="d-flex">
              <mdb-card border="primary" class="mb-3">
                <mdb-card-header><i class="fad fa-flag-usa mr-2"></i>美国L1签证</mdb-card-header>
                <mdb-card-body class="text-primary">
                  <mdb-card-title tag="h5">项目优势</mdb-card-title>
                  <mdb-card-text>1、审批速度快，平均审理周期仅4--6个月，可申请15天加急通道
                    2、最长可续签7年，美国公司正常运转满一年即可申办EB-1C转绿卡
                    3、配偶和21岁以下未婚子女可以同时获得L2签证，随同申请人登陆美国
                    4、配偶持L2签证可以在美自由工作，子女持L2签证可入读美国公立学校
                    5、对申请人的年龄、语言、和资产来源均没有要求

                  </mdb-card-text>
                  <a class="d-block text-right" @click="$router.push('/usa/l1')">了解详情>></a>

                </mdb-card-body>
              </mdb-card>
            </mdb-col>
          </mdb-row>
        </mdb-container>


      </div>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'UsaIndex',
    beforeRouteEnter(to, from, next) {
      window.document.body.style.backgroundImage = 'url(' + '' + ')';
      window.document.body.style.backgroundRepeat = 'no-repeat';
      window.document.body.style.backgroundSize = 'cover';
      window.document.body.style.backgroundAttachment='fixed'
      next();
    },
    beforeRouteLeave(to, from, next) {
      window.document.body.style.backgroundImage = '';
      next();
    }
  }
</script>

<style scoped>
  .opacityOuterUs {
    background: rgba(0, 0, 0, 0) !important;
    background: #000;
    filter: Alpha(opacity=0);
    color: white;
  }
</style>
